import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Tooltip from '@/design_system/Tooltip';
import IconAfterSales from '@/icons/AfterSales.svg';
import IconStore from '@/icons/Store.svg';
import IconTruck from '@/icons/Truck.svg';
import IconWorkshop from '@/icons/Workshop.svg';

export const StoreTraitIcon = () => {
  const { t } = useLingui();

  return (
    <Tooltip
      content={<Trans id="settings.organization.entities.entities.trait.store">Store</Trans>}
    >
      <Button
        variant="style-less"
        ariaLabel={t({
          id: 'settings.organization.entities.entities.trait.store',
          message: 'Store',
        })}
        style={{ color: 'inherit' }}
      >
        <IconStore />
      </Button>
    </Tooltip>
  );
};

export const AfterSalesTraitIcon = () => {
  const { t } = useLingui();

  return (
    <Tooltip
      content={
        <Trans id="settings.organization.entities.entities.trait.aftersales">After-Sales</Trans>
      }
    >
      <Button
        variant="style-less"
        ariaLabel={t({
          id: 'settings.organization.entities.entities.trait.aftersales',
          message: 'After-Sales',
        })}
        style={{ color: 'inherit' }}
      >
        <IconAfterSales />
      </Button>
    </Tooltip>
  );
};

export const WorkshopTraitIcon = () => {
  const { t } = useLingui();

  return (
    <Tooltip
      content={<Trans id="settings.organization.entities.entities.trait.workshop">Workshop</Trans>}
    >
      <Button
        variant="style-less"
        ariaLabel={t({
          id: 'settings.organization.entities.entities.trait.workshop',
          message: 'Workshop',
        })}
        style={{ color: 'inherit' }}
      >
        <IconWorkshop />
      </Button>
    </Tooltip>
  );
};

export const StockLocationTraitIcon = () => {
  const { t } = useLingui();

  return (
    <Tooltip
      content={
        <Trans id="settings.organization.entities.entities.trait.stocklocation">
          Stock Location
        </Trans>
      }
    >
      <Button
        variant="style-less"
        ariaLabel={t({
          id: 'settings.organization.entities.entities.trait.stocklocation',
          message: 'Stock Location',
        })}
        style={{ color: 'inherit' }}
      >
        <IconTruck />
      </Button>
    </Tooltip>
  );
};
